var map = {
	"./cityray/blue.png": "6871",
	"./cityray/grey.png": "d3af",
	"./cityray/light-grey.png": "cad3",
	"./cityray/white.png": "7729",
	"./coolray/grey.png": "2ef9",
	"./coolray/violet.png": "bde3",
	"./coolray/white.png": "9204",
	"./emgrand/black.png": "9e4b",
	"./emgrand/cyan.png": "2f13",
	"./emgrand/gold.png": "2d43",
	"./emgrand/grey.png": "19ec",
	"./emgrand/lilac.png": "c696",
	"./emgrand/white.png": "d833",
	"./ex5/black.png": "9526",
	"./ex5/blue.png": "30e5",
	"./ex5/dark-grey.png": "7c11",
	"./ex5/grey.png": "15e8",
	"./ex5/white.png": "9454",
	"./ex5_em-i/black.png": "0687",
	"./ex5_em-i/blue.png": "a19b",
	"./ex5_em-i/green.png": "0686",
	"./ex5_em-i/grey.png": "55cd",
	"./ex5_em-i/silver.png": "c1a7",
	"./ex5_em-i/white.png": "cfc6",
	"./monjaro_flagship_se/black.png": "92f2",
	"./monjaro_flagship_se/green.png": "7df9",
	"./monjaro_flagship_se/grey.png": "6c80",
	"./monjaro_flagship_se/silver.png": "22c0",
	"./monjaro_flagship_se/white.png": "19c6",
	"./okavango/black.png": "16ae",
	"./okavango/blue.png": "d385",
	"./okavango/grey.png": "29b3",
	"./okavango/white.png": "7c3a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a2d5";